export const storefrontLinks = [
    { to: '/', label: 'home', src: '/images/nav/home.png' },
    { to: '/shop', label: 'shop', src: '/images/nav/shop.png' },
    { to: '/portfolio', label: 'art', src: '/images/nav/art.png' },
    { to: '/events', label: 'events', src: '/images/nav/events.png' },
    { to: '/about', label: 'about', src: '/images/nav/about.png' },
];
